import { render, staticRenderFns } from "./ScheduleDetail.vue?vue&type=template&id=2bf22a9a"
import script from "./ScheduleDetail.vue?vue&type=script&lang=js"
export * from "./ScheduleDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports